class AdminController {
  constructor(User, $scope, $rootScope, $cookieStore, FunctionService) {
    console.log('Admin Controller...');
    this.name = 'admin';
    this.user = User.getUser();
    this.episodeValue = '';
    this.specialtyString = '';

    $rootScope.globals = $cookieStore.get('globals') || {};
    $cookieStore.remove('redirectURL');

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        if (response.functionSettings.EpisodeValue) {
          $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
          $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
        }
      }
    );
  }
}

export default AdminController;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin.controller.js